var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-v2"},[_c('div',{staticClass:"culture-grid-v2"},_vm._l((_vm.displayCultureList),function(item,i){return _c('div',{key:i,staticClass:"culture-item"},[_c('div',{staticClass:"item-num"},[_vm._v(_vm._s(_vm.formatIndex(i)))]),_c('h4',[_vm._v(_vm._s(item.title))]),_c('p',[_vm._v(_vm._s(item.desc))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }